<template>
	<div class="horizontal-ticket-list">
		<div v-if="loading" class="horizontal-ticket-list__loading">
			{{ context.translations.tickets_loading }}
		</div>
		<div v-if="!loading" class="horizontal-ticket-list__inner">
			<div class="horizontal-ticket-list__heading">
				<h2>{{ context.translations.tickets_tickets }}</h2>
			</div>

			<div class="horizontal-ticket-list__items">
				<div v-for="ticket in tickets" class="horizontal-ticket-list__item">
					<div class="horizontal-ticket-list__item-date horizontal-ticket-list__item-child-25">
						{{ formatDate(ticket.date) }}
					</div>
					<div class="horizontal-ticket-list__item-child-25">
						{{ ticket.time }}
					</div>
					<div class="horizontal-ticket-list__item-child-50">
						<a class="lillan-button-small" v-bind:href="ticket.url" v-if="ticket.availability === '1'">
							<span v-html="require('!raw-loader!../../images/icon-ticket.svg').default"></span>
							<span>{{ context.translations.tickets_buy_tickets }}</span>
						</a>
					</div>
				</div>
				<a v-bind:href="context.buy_link" v-if="context.buy_link" class="horizontal-ticket-list__button">
					<span class="horizontal-ticket-list__button-icon">{{ context.translations.tickets_see_all }}</span>
					<span v-html="require('!raw-loader!../../images/icon-arrow.svg').default"></span>
				</a>
			</div>
		</div>

	</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

//moment.locale('sv');
moment.locale(lillan_language.current_lang);

export default {
	props: [ 'context' ],
	data: function() {
		return {
			tickets: [],
			all: null,
			loading: true,
		};
	},
	mounted() {
		axios.get('/wp-json/lillan/v1/ticket-list', {
			params: {
				id: this.context.hkt_id,
			},
		}).then(response => {
			console.log(response);
			this.tickets = response.data.tickets;
			this.all = response.data.all;
			this.loading = false;
		});
	},
	methods: {
		formatDate(date) {
			let formattedDate = moment(date, 'D.M.YYYY');
			return formattedDate.format('dddd D.M.YYYY');
		},
	},
};
</script>
